import { render } from "./StudentEnterWaitingModal.vue?vue&type=template&id=1e355388&scoped=true"
import script from "./StudentEnterWaitingModal.vue?vue&type=script&lang=js"
export * from "./StudentEnterWaitingModal.vue?vue&type=script&lang=js"

import "./StudentEnterWaitingModal.vue?vue&type=style&index=0&id=1e355388&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\project\\sparta\\sparta-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e355388"]])

export default __exports__